import { ServiceObject } from "app/models/serviceObject";

export class Asset extends ServiceObject  {
  public status: Asset.Status;
}

export namespace Asset {

  export enum Status {
    NotInstalled,
    Installed
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/asset.ts